import { languageMap } from ".."

languageMap.uorazor = {
	comments: {
		line: "#",
	},
}
